/**
 * Who a library row is for, in the five names Lifeway's brand system uses.
 *
 * Lives beside the tokens rather than in a feature because the audience colour
 * tokens are keyed by these names and `shared/ui` reads them — the dependency in
 * this codebase runs features -> shared, never the other way.
 */
export type Audience = "students" | "kids" | "women" | "men" | "adults"

/**
 * The audiences that name a ministry. `adults` is what the classifier returns
 * when none matched, so it has no colour and no label of its own — a card it
 * lands on wears the tone of the section it is in.
 */
export type Ministry = Exclude<Audience, "adults">

export const AUDIENCES: readonly Audience[] = ["students", "kids", "women", "men", "adults"]

export const MINISTRIES: readonly Ministry[] = ["students", "kids", "women", "men"]

const LABELS: Record<Audience, string> = {
  students: "Students",
  kids: "Kids",
  women: "Women",
  men: "Men",
  adults: "Adults",
}

/** The label is what distinguishes two audiences that share a brand colour. */
export const audienceLabel = (audience: Audience): string => LABELS[audience]

/** The label a card shows, or nothing at all where the classifier placed no ministry. */
export const ministryLabel = (who: Audience): string | undefined => (who === "adults" ? undefined : LABELS[who])
